export default __webpack_public_path__ + "static/media/emailIcon.74e385fe.svg";